import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isOpen: false,
	requestId: null,
	request: null, // { url, method, body, headers }
	entityId: null,
	conflict: null, // backend provided dependency details (optional)
};

const softDeleteSlice = createSlice({
	name: 'softDelete',
	initialState,
	reducers: {
		showSoftDeleteConflict(state, action) {
			const { requestId, request, entityId, conflict } = action.payload;
			state.isOpen = true;
			state.requestId = requestId ?? null;
			state.request = request;
			state.entityId = entityId ?? null;
			state.conflict = conflict ?? null;
		},
		hideSoftDeleteConflict(state) {
			state.isOpen = false;
			state.requestId = null;
			state.request = null;
			state.entityId = null;
			state.conflict = null;
		},
	},
});

export const { showSoftDeleteConflict, hideSoftDeleteConflict } =
	softDeleteSlice.actions;
export default softDeleteSlice.reducer;
